import { BpAnchor } from '../../components/text/anchor/BpAnchor'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface SerpCellProps {
  search_screen_url: string
}

export const SerpCell = ({ search_screen_url }: SerpCellProps) => {
  const { t } = useTranslation()

  return (
    <BpAnchor href={search_screen_url} target='_blank'>
      {t('buttons.viewScreenshot')}
    </BpAnchor>
  )
}
